import { BudgetSiSClassification } from '@callmart/types';
import api from './index';

export interface WorkingUnitClassification {
    id: number;
    worktypeId: number;
    channelId: number;
    taskId: number;
    budgetSiSClassification: BudgetSiSClassification | null;
    worktype?: { id: number; worktype: string };
    channel?: { id: number; name: string };
    task?: { id: number; name: string };
}

const BASE = '/budget/working-unit-classifications';

export const getWorkingUnitClassifications = async (): Promise<WorkingUnitClassification[]> => {
    return api.get(BASE).then((res) => res.data);
};

export const updateWorkingUnitClassification = async ({
    id,
    budgetSiSClassification,
}: {
    id: number;
    budgetSiSClassification: BudgetSiSClassification | null;
}): Promise<WorkingUnitClassification> => {
    return api.patch(`${BASE}/${id}`, { budgetSiSClassification }).then((res) => res.data);
};
